import { render, staticRenderFns } from "./DialogMovePlanTasks.vue?vue&type=template&id=36b358ac&scoped=true"
import script from "./DialogMovePlanTasks.vue?vue&type=script&lang=js"
export * from "./DialogMovePlanTasks.vue?vue&type=script&lang=js"
import style0 from "./DialogMovePlanTasks.vue?vue&type=style&index=0&id=36b358ac&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b358ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b358ac')) {
      api.createRecord('36b358ac', component.options)
    } else {
      api.reload('36b358ac', component.options)
    }
    module.hot.accept("./DialogMovePlanTasks.vue?vue&type=template&id=36b358ac&scoped=true", function () {
      api.rerender('36b358ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogMovePlanTasks.vue"
export default component.exports